module.exports = __webpack_public_path__ + "quotesCover.6c705d4103c674ae44ed.jpg";


//////////////////
// WEBPACK FOOTER
// C:/Users/Artem/Desktop/Programming/studio/creativeDigital/src/assets/coverPicks/quotesCover.jpg
// module id = ../../../../../src/assets/coverPicks/quotesCover.jpg
// module chunks = 0